module.exports = __webpack_public_path__ + "img/857-2844bf.png";